import { InputHTMLAttributes } from "react";
import lockIcon from "../../../../../../../assets/icons/lock.svg";

interface InputBlockProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  width?: string;
  isLocked?: boolean;
}

export const InputBlock = ({
  name,
  width,
  isLocked,
  ...rest
}: InputBlockProps) => {
  return (
    <div className={`text-sm flex ${width ? width : "w-full"} flex-col gap-2`}>
      <p className="text-sm font-medium text-gray-800">{name}</p>
      <div className="flex h-10 justify-between rounded-sm bg-gray-200 px-2">
        <input
          {...rest}
          className="h-full w-full bg-transparent text-gray-600 outline-none placeholder:text-gray-500"
          disabled={isLocked}
          name={name}
        />
        {isLocked && <img src={lockIcon} alt="" className="m-0 w-5" />}
      </div>
    </div>
  );
};
